// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","easeInOutQuad":"cubic-bezier(.455,.03,.515,.955)","content":"loader__content___7jDeS","a":"loader__a___1WIBs","notSupported":"loader__notSupported___3UYia layout__content___2G64l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/loader.css
// module id = 161
// module chunks = 0